import React, {useState} from 'react'
import {Attendee} from 'Event/attendee'
import {useOrganization} from 'organization/OrganizationProvider'
import {api} from 'lib/url'
import {Form} from 'organization/Event/FormsProvider'
import {Answer} from 'Event/SubmissionsProvider'
import PageHeaderButton from 'lib/ui/PageHeader/PageHeaderButton'
import SelectTestAttendeeDialog from 'organization/Event/Form/FormTest/SelectTestAttendeeDialog'
import {useQueryClient} from 'react-query'

export default function FormTest(props: {form: Form}) {
  const send = useSendTest()
  const {form} = props
  const qc = useQueryClient()
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const toggleVisible = () => {
    setIsVisible((current) => !current)
  }

  const onSelect = async (attendee: Attendee | null, answers: Answer[]) => {
    if (!attendee) return

    return send(form, attendee, answers).then(() => {
      qc.invalidateQueries([
        'forms',
        form.id,
        'submissions',
        {status: 'incoming'},
      ])
    })
  }

  const processing = false

  if (form.questions.length === 0) {
    return null // Don't show if there aren't questions
  }

  return (
    <>
      <PageHeaderButton
        text="Test answer"
        aria-label="test form submission"
        disabled={processing}
        onClick={toggleVisible}
        variant="outlined"
        color="primary"
      />
      <SelectTestAttendeeDialog
        visible={isVisible}
        onClose={toggleVisible}
        onSelect={onSelect}
        form={form}
      />
    </>
  )
}

export function useSendTest() {
  const {client} = useOrganization()

  return async (
    form: Form,
    attendee: Attendee,
    answers: Answer[],
  ): Promise<void> => {
    const url = api(`/forms/${form.id}/test_submission`)

    return await client.post(url, {
      attendee_id: attendee.id,
      answers,
    })
  }
}
